import React, { useState, useEffect } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import i18n from "i18n";
import { useTranslation } from 'react-i18next';

// custom pages
import Logo from 'assets/img/logo.png';
import { consentStyles } from './styles';
import auth from 'apis/auth/auth';
import IconButton from '@material-ui/core/IconButton';

// US
import HSBanner from 'assets/img/Banner-Image.png';
import Congratulations from 'assets/img/thrive-logo.png';
import ThriveLogo from 'assets/img/thrive-logo.png';

// CA
import HSBannerCA from 'assets/img/Banner-Image.png';
import CongratulationsCA from 'assets/img/thrive-logo.png';
import ThriveLogoCA from 'assets/img/thrive-logo.png';

// material-ui
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import LanguageSharpIcon from '@material-ui/icons/LanguageSharp';
import Grid from '@material-ui/core/Grid';
import {
  withStyles,
  createMuiTheme,
  ThemeProvider,
} from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import { imageHandler } from 'helpers/imageHandler';

const formLabelsTheme = createMuiTheme({
  overrides: {
    MuiFormLabel: {
      asterisk: {
        color: '#db3131',
        '&$error': {
          color: '#db3131',
        },
      },
    },
  },
  palette: {
    primary: {
      main: '#616161',
    },
  },
});

function UploadConsent() {
  const classes = consentStyles();
  const location = useLocation();
  const { uploadConsent, getAdminConsentStatus, downloadConsentForm } = auth();
  const [file, setFile] = useState({});
  const [fileType, setFileType] = useState('');
  const [fileName, setFileName] = useState('');
  const [message, setMessage] = useState('');
  const [status, setStatus] = useState('');
  const [data, setData] = useState({});
  const param = new URLSearchParams(location.search);
  const token = param.get('token');
  const [loading, setLoading] = useState(false);
  const [org, setOrg] = useState("Henry Schein Dental");
  const { t } = useTranslation();

  useEffect(() => {
    handleGetAdminConsentStatus();
  }, []);

  useEffect(() => {
    i18n.changeLanguage(param.get("lang"));
    let temp = param.get('org');
    if (temp == "ca") {
      setOrg("Henry Schein Canada");
    } else {
      setOrg("Henry Schein Dental");
    }
  }, []);

  const handleGetAdminConsentStatus = async () => {
    try {
      let res = await getAdminConsentStatus(token);
      if (res && res?.type == 'success') {
        setStatus(res?.status);
        setMessage(res?.message);
        setData(res);
        return;
      }
      if (res && res?.message) {
        setMessage(param.get("lang") == "fr" ? res?.french_message : res?.message);
      } else {
        setMessage('Unauthorized');
      }
      setStatus('Unauthorized');
    } catch (e) {
      console.log({ e });
    }
  };

  async function handleSubmit() {
    try {
      if (fileName == '' || fileType == '' || file == {}) {
        return toast.error(t('Please upload the file'), {
          toastId: 'uploadWarning',
        });
      }
      setLoading(true);
      let input = new FormData();
      input.append('fileName', fileName);
      input.append('fileType', fileType);
      input.append('file', file);
      input.append('loyaltyId', data?.loyalty_id);
      input.append('userId', data?.user);
      input.append('DATABASE', data.db);
      let res = await uploadConsent(input);
      setLoading(false);
      if (res && res?.type == 'success') {
        setMessage(param.get("lang") == "fr" ? res?.french_message : res?.message);
        setStatus('Processed');
        return;
      }
    } catch (e) {
      console.log({ e });
    }
  }

  const download = async () => {
    try {
      let lang = param.get("lang");
      let type = 1;
      if (org == "Henry Schein Canada" && lang == "en") {
        type = 2;
      }
      if (org == "Henry Schein Canada" && lang == "fr") {
        type = 3;
      }
      let download = await downloadConsentForm(type);
      if (download && Object.keys(download).length > 0) {
        var buffer = Buffer.from(download?.data);
        var blob = new Blob([buffer], { type: 'application/pdf' });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        var fileName = download?.fileName;
        link.download = fileName;
        link.click();
      }
    } catch (err) {
      console.log({ err });
    }
  };

  function handleRedirect() {
    if (org == "Henry Schein Canada") {
      window.open('https://www.henryschein.ca')
    } else {
      window.open('https://www.henryschein.com')
    }
  }

  return (
    <div className={classes.mainDiv}>
      <div className={classes.gridContainer}>
        <div className={classes.logoImgDiv}>
        <img
  src={
    org === "Henry Schein Dental"
      ? imageHandler?.[org]?.[i18n?.language]?.["Newheader"]
      : imageHandler?.[org]?.[i18n?.language]?.["nullHeaderLogo"]
  }
  className={classes.logoImg}
/>
        </div>
        <div className={classes.flexBoxDiv}>
          <Grid item className={classes.backToGrid}>
            <IconButton
              className={classes.globeIconBtn}
              onClick={handleRedirect}
            >
              <LanguageSharpIcon className={classes.languageIcon} />
            </IconButton>
            <br />
            <div
              className={classes.backtoHendry}
              onClick={handleRedirect}
            >
              {t(org)}
            </div>
          </Grid>
        </div>
      </div>
      <div className={classes.HSBanner}>
        <img src={imageHandler?.[org]?.[param?.get("lang")]?.["banner"]} alt='' width='100%' height='' />
      </div>

      <div className={classes.mainDiv}>
        {status === 'Inprocessed' && (
          <Card className={classes.card}>
            <div className={classes.divText}>{t("Upload Activation Form")}</div>
            <div className={classes.divSubText}>
              {t("Upload your customer's signed Thrive Rewards Activation Form")}.{" "}
              {t("Please ensure the customer's practice information and signature are filled in before uploading")}.{" "}
              {t("Following submission, please allow 3-5 business days for account activation")}.{" "}
              {t("You can")}{' '}
              <a
                style={{
                  color: '#4472c4',
                  textDecoration: 'underline',
                }}
                onClick={download}
              >
                {t("download Thrive Rewards Activation Form")}
              </a>
            </div>

            <div>
              <ThemeProvider theme={formLabelsTheme}>
                <button style={{ padding: "2px 4px", margin: "10px", cursor: "pointer" }} onClick={() => document.getElementById('demo').click()}>{t("Choose File")}</button>
                <input
                  id='demo'
                  type='file'
                  placeholder='import csv'
                  style={{ marginLeft: 70, display: 'none' }}
                  accept='image/jpg, image/jpeg, image/png, application/pdf'
                  onChange={(event) => {
                    let fileName = event.target.files?.[0].name;
                    let file = event.target.files?.[0];
                    let type = event.target.files?.[0].type;
                    let fileSize = event.target.files?.[0].size / 1024 / 1024; // Mega Bytes converison
                    let comp_file;
                    setFileName(fileName);
                    setFileType(type);
                    setFile(file);
                  }}
                >
                </input>
                <span>{fileName}</span>
              </ThemeProvider>
              {/* <div className={classes.consentBtnDiv}> */}
              <Button
                className={classes.uploadConsentBtn}
                onClick={() => {
                  if (loading) return;
                  handleSubmit();
                }}
              >
                {loading ? t('Uploading') : t('Submit')}
              </Button>
            </div>
            {/* </div> */}
          </Card>
        )}
        {status === 'Processed' && (
          <div>
            <img src={org == "Henry Schein Dental" ?imageHandler?.[org]?.[param?.get("lang")]?.["NewCongrulations"]:imageHandler?.[org]?.[param?.get("lang")]?.["congratulationLogo"]} alt='' width='40%' />
            <div className={classes.message}>
              <b>{message}</b>
            </div>
            <p>
              {t("Please allow 3-5 business days for the activation process to be completed")}.
            </p>
            <p>
              <strong>{t("Questions?")}{" "}</strong>{org == "Henry Schein Dental" ?
                t("Contact our Thrive Rewards Customer Service Team at 1-800-888-6684 (8AM - 8PM EST Monday-Friday)") :
                t("Contact our Thrive Rewards Customer Service Team at 1-800-668-5558 (8AM - 8PM EST Monday-Friday)")
              }
            </p>
          </div>
        )}
        {status === 'Unauthorized' && (
          <div>
            <div className={classes.message}>{message}</div>
          </div>
        )}
      </div>
    </div>
  );
}

export default UploadConsent;
